module.exports = __webpack_public_path__ + "static/media/fillingBg2.d8be8b0d.png";